import ErrorHandlerService from '@/modules/common/services/error-handler.service'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Container from 'typedi'
import { mapState } from 'vuex'
import SecurityContext from '@/modules/common/services/security-context.service'

declare global {
  interface Window {
    $sleek: any;
    SLEEK_PRODUCT_ID: any;
  }
}

@Component({
  name: 'GtrFeedback',
  computed: {
    ...mapState('security', ['currentUser'])
  }
})

export default class GtrFeedback extends Vue {
  private static sleekInitialized = false

  data () {
    return {
      value: false,
      plan: null,
      _currentUser: null
    }
  }

  @Watch('currentUser', { immediate: true })
  onCurrentUserChange (payload: any) {
    if (payload) {
      this.$data._currentUser = payload
    }
  }

  mounted () {
    this.initializeSleekPlan()
  }

  initializeSleekPlan () {
    // Check if already initialized globally
    if (GtrFeedback.sleekInitialized) {
      return
    }

    // Check if script is already loaded
    const existingScript = document.querySelector('script[src="https://client.sleekplan.com/sdk/e.js"]')
    if (existingScript) {
      GtrFeedback.sleekInitialized = true
      return
    }

    const yourBearerToken = Container.get(SecurityContext).token()
    window.SLEEK_PRODUCT_ID = 569570595
    // Define the SSO function before loading the script
    window.$sleek = window.$sleek || {}
    window.$sleek.sso = function (callbackMethod) {
      fetch(`${process.env.VUE_APP_API_URL}sleekplan-sso`, {
        headers: {
          Authorization: `Bearer ${yourBearerToken}`
        }
      })
        .then(response => response.json())
        .then(data => {
          const userToken = data.ssoToken
          callbackMethod({ token: userToken })
        })
        .catch(err => {
          Container.get(ErrorHandlerService).error(err)
        })
    }

    // Load the Sleekplan widget
    const script = document.createElement('script')
    script.src = 'https://client.sleekplan.com/sdk/e.js'
    script.async = true
    document.body.appendChild(script)

    // Mark as initialized
    GtrFeedback.sleekInitialized = true
  }
}
